// ARROW
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// import IconButton from '@material-ui/core/IconButton';
// import { makeStyles } from '@material-ui/core/styles';
// const useStyles = makeStyles((theme) => ({
//   button: {
//     color: 'black',
//     '&:hover': {
//       backgroundColor: 'transparent',
//     }
//   },
// }));
// export default function BackButton(props) {
//   const styles = useStyles()
//   return (
//     <IconButton aria-label="back" size="medium" className={styles.button} onClick={onClick}>
//       <ArrowBackIosIcon fontSize="inherit" />
//     </IconButton>
//   )
// }
import Button from '../Button/Button';
import i18n from '../../i18n';

export default function BackButton({ small, onClick }) {
  if (small)
    return <Button type="secondary-small" text={i18n.t('common.back')} onClick={onClick} />;

  return <Button type="secondary" text={i18n.t('common.back')} onClick={onClick} />;
}
